import { RouteConfig } from 'vue-router'
import Layout from '@/common/components/manage/layout.vue'
// import SubLayout from '@/common/components/manage/sub-layout.vue'
import SubLayout from '@/common/components/manage/components/AppMain.vue'
class DynamicRoutes {
  static parseRouteArray(srcData: any, parentPath: string): RouteConfig[] {
    const ret: RouteConfig[] = []
    for (let i = 0; i < srcData.length; i++) {
      DynamicRoutes.appendRouter(ret, srcData[i], parentPath)
    }
    return ret
  }

  static appendRouter(
    rootRouter: RouteConfig[],
    menuInfo: any,
    parentPath: string
  ) {
    let componentObj = undefined
    if (menuInfo.component == 'Layout') {
      componentObj = Layout
    } else if (menuInfo.component == 'ParentView') {
      componentObj = SubLayout
    } else {
      componentObj = (resolve: any) =>
        require([`@/views/${menuInfo.component}.vue`], resolve)
    }
    if (parentPath) {
      parentPath = parentPath + '/'
    }
    let routeName = parentPath.replace('/', '') + menuInfo.name
    while (routeName.indexOf('/') >= 0) {
      routeName = routeName.replace('/', '')
    }
    const item: RouteConfig = {
      path: parentPath + menuInfo.path,
      name: routeName,
      redirect: menuInfo.redirect,
      meta: {
        title: menuInfo.meta.title,
        icon: menuInfo.meta.icon,
        hidden: menuInfo.hidden === true ? true : false,
        alwaysShow: menuInfo.alwaysShow === true ? true : false
      },
      component: componentObj
    }
    if (menuInfo.children && menuInfo.children.length > 0) {
      item.children = DynamicRoutes.parseRouteArray(
        menuInfo.children,
        item.path
      )
    }
    rootRouter.push(item)
  }
}

export default DynamicRoutes
